import { render, staticRenderFns } from "./VoiceAnimationV2.vue?vue&type=template&id=2b1a9c93&scoped=true&"
import script from "./VoiceAnimationV2.vue?vue&type=script&lang=js&"
export * from "./VoiceAnimationV2.vue?vue&type=script&lang=js&"
import style0 from "./VoiceAnimationV2.vue?vue&type=style&index=0&id=2b1a9c93&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1a9c93",
  null
  
)

export default component.exports